import BorderBox4 from './main'
export default function (Vue) {
  Vue.component(BorderBox4.name, BorderBox4)
}



// WEBPACK FOOTER //
// ./src/components/border/border-box-4/index.js